import { useCallback, useState } from 'react';
import { useChangesSnackbar } from 'src/hooks/snackbar/useChangesSnackbar';
import { AnnouncementTypeEnum } from 'src/infrastructure/rest-api/api-types';

import { useApiMutation } from 'src/infrastructure/rest-api/useApi';

interface Props {
    id: number | undefined | null;
    title: string;
    description: string;
    type: AnnouncementTypeEnum;
    resolved: boolean;
}

export const useUpdateAnnouncement = ({ id, title, description, type, resolved }: Props) => {
    const [updateAnnouncement] = useApiMutation('/api/announcements', 'put', {
        update(data, _variables, queryClient) {
            queryClient.setQueryData(['/api/announcements'], data);
        },
    });

    const [isUpdating, setIsUpdating] = useState(false);

    const showSnackbar = useChangesSnackbar();

    const updatingAnnouncement = useCallback(async () => {
        if (id === undefined || id === null) return;
        setIsUpdating(true);

        try {
            const response = await updateAnnouncement({
                body: {
                    announcementId: id,
                    title,
                    description,
                    announcementTypeEnum: type,
                    moduleEnum: null,
                    resolved: resolved ? new Date().toISOString() : null,
                },
            });
            showSnackbar(undefined, {
                showCubeTimer: false,
                successMessage: `Announcement '${title}' has been updated`,
            });
            return response;
        } catch (err) {
            showSnackbar(err);
        } finally {
            setIsUpdating(false);
        }
    }, [id, updateAnnouncement, title, description, type, resolved, showSnackbar]);

    return [updatingAnnouncement, { loading: isUpdating }] as const;
};
